import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';
import Activity from './activity';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AuhMethods } from '../../services/auth';
import { CurrentAuthMethod } from '../../@jumbo/constants/AppConstants';

const ExtraPages = ({ match }) => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route component={lazy(() => import('./404'))} />
      </Switch>
    </Suspense>
  );
};

function doRedirect(url, token2) {
  const token = localStorage.getItem('token');
  const senddata = {
    Action: 'Redirect',
    token: token,
    URL: url,
  };

  var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
  axios
    .post(pmsUrl, senddata, {
      withCredentials: true,
    })
    .then(res => {
      window.location = url;
    });
}

const MyPages = ({ match }) => {
  const requestedUrl = match.url.replace(/\/$/, '');
  const { authUser } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const history = useHistory();
  //  const query = new URLSearchParams(this.props.location.search);

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/editors`} />
        <Route path={`${requestedUrl}/timeline`} component={lazy(() => import('./timeline'))} />
        <Route path={`${requestedUrl}/invoices`} component={lazy(() => import('./invoices'))} />
        <Route path={`${requestedUrl}/calendar`} component={lazy(() => import('./calendar'))} />
        <Route path={`${requestedUrl}/profile`} component={lazy(() => import('./profile'))} />
        <Route path={`${requestedUrl}/selfciconfig`} component={lazy(() => import('./selfciconfig'))} />
        <Route path={`${requestedUrl}/selfcisend`} component={lazy(() => import('./selfcisend'))} />
        <Route path={`${requestedUrl}/hkrooms`} component={lazy(() => import('./hkrooms'))} />
        <Route path={`${requestedUrl}/cockpit`} component={lazy(() => import('./cockpit'))} />
        <Route path={`${requestedUrl}/chat`} component={lazy(() => import('./chat2'))} />
        <Route path={`${requestedUrl}/crm`} component={lazy(() => import('./crm'))} />
        <Route path={`${requestedUrl}/chatconfigure`} component={lazy(() => import('./chatconfigure'))} />
        <Route path={`${requestedUrl}/cockpit-wbp`} component={lazy(() => import('./cockpit-wbp'))} />
        <Route path={`${requestedUrl}/dashboard`} component={lazy(() => import('./dashboard'))} />
        <Route path={`${requestedUrl}/messages/configure`} component={lazy(() => import('./messageconfigure'))} />
        <Route path={`${requestedUrl}/messages`} component={lazy(() => import('./messages'))} />
        <Route path={`${requestedUrl}/reviews/configure`} component={lazy(() => import('./reviewconfigure'))} />
        <Route path={`${requestedUrl}/reviews`} component={lazy(() => import('./reviews'))} />
        <Route path={`${requestedUrl}/selectproperty`} component={lazy(() => import('./selectproperty'))} />
        <Route path={`${requestedUrl}/feedback`} component={lazy(() => import('./feedback'))} />
        <Route path={`${requestedUrl}/upgrade`} component={lazy(() => import('./upgrade'))} />
        <Route path={`${requestedUrl}/posconfigure`} component={lazy(() => import('./posorderconfigure'))} />
        <Route path={`${requestedUrl}/posorders`} component={lazy(() => import('./posorders'))} />
        <Route path={`${requestedUrl}/statistics`} component={lazy(() => import('./statistics'))} />
        <Route path={`${requestedUrl}/statisticsm`} component={lazy(() => import('./statisticsm'))} />
        <Route path={`${requestedUrl}/availability/:id`} component={lazy(() => import('./availability'))} />
        <Route path={`${requestedUrl}/yield/:id`} component={lazy(() => import('./yield'))} />
        <Route path={`${requestedUrl}/yield`} component={lazy(() => import('./yield'))} />
        <Route path={`${requestedUrl}/rates/:id`} component={lazy(() => import('./rates'))} />
        <Route path={`${requestedUrl}/parityrates/:id`} component={lazy(() => import('./parityrates'))} />
        <Route path={`${requestedUrl}/bookings/:id`} component={lazy(() => import('./bookings'))} />
        <Route path={`${requestedUrl}/bookings`} component={lazy(() => import('./bookings'))} />
        <Route path={`${requestedUrl}/discounts`} component={lazy(() => import('./discounts'))} />
        <Route path={`${requestedUrl}/travelagents`} component={lazy(() => import('./travelAgents'))} />
        <Route path={`${requestedUrl}/inquires`} component={lazy(() => import('./inquires'))} />
        <Route path={`${requestedUrl}/offers`} component={lazy(() => import('./offers'))} />
        <Route path={`${requestedUrl}/guests/configure`} component={lazy(() => import('./guestsconfigure'))} />
        <Route path={`${requestedUrl}/guests`} component={lazy(() => import('./guests'))} />
        <Route path={`${requestedUrl}/cash-register`} component={lazy(() => import('./cash-register'))} />
        <Route path={`${requestedUrl}/bookingsm`} component={lazy(() => import('./bookingsm'))} />
        <Route path={`${requestedUrl}/history`} component={lazy(() => import('./history'))} />
        <Route path={`${requestedUrl}/activitylog`} component={lazy(() => import('./activitylog'))} />
        <Route path={`${requestedUrl}/import-rate`} component={lazy(() => import('./import-rates'))} />
        <Route path={`${requestedUrl}/revenue/cockpit`} component={lazy(() => import('./revenue'))} />
        <Route path={`${requestedUrl}/revenue/rules`} component={lazy(() => import('./revenuerules'))} />
        <Route path={`${requestedUrl}/revenue/rateshopper`} component={lazy(() => import('./rateshopper'))} />
        <Route path={`${requestedUrl}/revenue/marketinsight`} component={lazy(() => import('./marketinsight'))} />
        <Route path={`${requestedUrl}/revenue/configure`} component={lazy(() => import('./revenueconfigure'))} />
        <Route path={`${requestedUrl}/revenue/analytics`} component={lazy(() => import('./revenueanalytics'))} />
        <Route path={`${requestedUrl}/revenue/reports`} component={lazy(() => import('./revenuereports'))} />
        <Route path={`${requestedUrl}/loyaltyrules`} component={lazy(() => import('./loyalityrules'))} />
        <Route path={`${requestedUrl}/loyalty`} component={lazy(() => import('./loyality'))} />
        <Route
          path={`${requestedUrl}/logout`}
          component={lazy(() => {
            dispatch(AuhMethods[CurrentAuthMethod].onLogout2({}));
            //history.push('/mobile');
            //window.location = '/mobile';
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/invoices`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_invoices', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/hotels`}
          component={lazy(() => {
            if (authUser != null) doRedirect('https://secure.webbookingpro.com/index.php?admin=hotels_info', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/meal-plans`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_meal_plans', authUser.token);

            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/currencies`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_currencies', authUser.token);

            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/rate-plans`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_pricelists', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/coupons`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_coupons', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/promotions`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_campaigns', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/payment-gateways`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect(
                'https://secure.webbookingpro.com/index.php?admin=mod_booking_hotel_payment_gateways',
                authUser.token,
              );
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/accounts-agencies`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_customers_agencies', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/accounts-customers`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_customers_management', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/taxes`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_taxes', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/extras`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_extras', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/packages`}
          component={lazy(() => {
            if (authUser != null)
              doRedirect('https://secure.webbookingpro.com/index.php?admin=mod_booking_packages', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/tasks`}
          component={lazy(() => {
            if (authUser != null) doRedirect('/admin/mod_tasks', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/virtualconcierge`}
          component={lazy(() => {
            if (authUser != null) doRedirect('/admin/mod_vc', authUser.token);
            return null;
          })}
        />
        <Route
          path={`${requestedUrl}/help`}
          component={lazy(() => {
            window.location.href = 'https://webbookingpro.com/support/';
            return null;
          })}
        />
        <Route path={`${requestedUrl}/bookingsite`} component={lazy(() => import('./bookingsite'))} />
        Y
        <Route path={`${requestedUrl}/quickreservation`} component={lazy(() => import('./quickreservation'))} />
        <Route path={`${requestedUrl}/activity-today`}>
          <Activity day="today" />
        </Route>
        <Route path={`${requestedUrl}/arrivals`}>
          <Activity day="arrivals" />
        </Route>
        <Route path={`${requestedUrl}/departures`}>
          <Activity day="departures" />
        </Route>
        <Route path={`${requestedUrl}/stay`}>
          <Activity day="stay" />
        </Route>
        <Route component={lazy(() => import('./404'))} />
      </Switch>
    </Suspense>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default MyPages;

//export default ExtraPages;
